import { AppTextField } from './AppTextField';
import { Icon } from './Icon';

/**
 * Строка поиска. Отдельно от `AppTextField` ровно по одной причине: у неё всегда есть
 * крестик «Очистить». Три собранные вручную копии разошлись — в одной крестика не было.
 *
 * Поиск показывается везде, где выбирают клиента или дело, **независимо от числа
 * вариантов** ([D-31](docs/DECISIONS.md)): юрист с тремя клиентами не знает, что поиск
 * появится потом, и видит просто маленький список без него.
 */
export function AppSearchField({
  value,
  onChange,
  placeholder = 'Поиск',
  autoFocus = false,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  return (
    <AppTextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoFocus={autoFocus}
      search
      trailing={
        value
          ? {
              icon: <Icon name="close" size={20} />,
              label: 'Очистить',
              onClick: () => onChange(''),
            }
          : undefined
      }
    />
  );
}
